import { Container } from '@eliadmin/core/src/components/ui/container';
import { useProductConfVariants } from '@eliadmin/core/src/hooks/proform-product-conf';
import { useProductOrnament } from '@eliadmin/core/src/hooks/proform-product-ornaments';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useVariantsStore } from '@eliadmin/core/src/stores/variant-store';
import { getProformImageUrl } from '@eliadmin/core/src/utils/proform-utils';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import Image from '@eliadmin/core/src/components/image/image-wrapped';

export function ProductTabVariants() {
  const product = useVariantsStore(s => s.product);
  const variants = useProductConfVariants(product.code);
  const ornaments = useProductOrnament(product.code);

  const { t } = useTranslations();

  return (
    <Container className={cn('flex flex-col px-2 @container', 'ea-product-detail-tab-variants')}>
      <h2 className="mb-4 mt-4 text-base font-bold text-muted-foreground">{t('text1046')}</h2>
      <div className="w-full columns-1 gap-x-5 gap-y-6  @md:columns-2 @lg:columns-3 @xl:columns-4">
        {ornaments.data?.length
          ? ornaments.data.map(ornament => {
              if (!ornament) return;

              return (
                <div
                  key={ornament.kod}
                  className="group relative col-span-12 flex flex-col items-start justify-start gap-4  @sm:col-span-6 @md:col-span-4"
                >
                  {ornament.pic && (
                    <Image
                      src={getProformImageUrl(ornament.pic)}
                      alt={ornament.kod}
                      width={0}
                      height={0}
                      sizes="100vw"
                      className="h-auto w-full object-contain"
                    />
                  )}
                  <div className="flex flex-col">
                    <h4 className="text-left text-base font-bold">{ornament.popis}</h4>
                  </div>
                  {/* <div className={cn('flex-col items-center justify-center')}>
                  <div className="flex flex-col items-start gap-4">
                    {variantData.map(item => (
                      <div key={item.label} className="flex flex-col items-start">
                        <h5 className="text-xs font-semibold text-muted-foreground">{item.label}</h5>
                        <p className="text-sm">{item.value}mm</p>
                      </div>
                    ))}
                  </div>
                </div> */}
                </div>
              );
            })
          : (variants.data ?? []).map(variant => {
              if (!variant) {
                return null;
              }

              const variantData = [
                {
                  label: t('text1048'),
                  value: variant.vyska_min,
                },
                {
                  label: t('text1050'),
                  value: variant.vyska_max,
                },
                {
                  label: t('text1049'),
                  value: variant.sirka_min,
                },
                {
                  label: t('text1051'),
                  value: variant.sirka_max,
                },
              ];

              return (
                <div
                  key={variant.kod}
                  className="group relative col-span-12 flex break-inside-avoid flex-col items-start justify-start gap-4 pb-12 @sm:col-span-6 @md:col-span-4"
                >
                  {variant.pic && (
                    <Image
                      src={getProformImageUrl(variant.pic)}
                      alt={variant.kod}
                      width={0}
                      height={0}
                      sizes="100vw"
                      className="h-auto w-full object-contain"
                    />
                  )}
                  <div className="flex flex-col">
                    <h6 className="text-left text-xs font-medium">{variant.kod}</h6>
                    <h4 className="text-left text-sm font-bold">{variant.popis}</h4>
                  </div>
                  <div className={cn('flex-col items-center justify-center')}>
                    <div className="flex flex-col items-start gap-1">
                      {variantData.map(item => (
                        <div key={item.label} className="flex flex-col items-start">
                          <h5 className="text-xs font-semibold text-muted-foreground">
                            {item.label}
                          </h5>
                          <p className="text-sm">{item.value}mm</p>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              );
            })}
      </div>
    </Container>
  );
}
